/** Influencer nav labels and helper copy (Phase 6.4). Descriptions are hover tooltips, not inline sidebar text. */

export const INFLUENCER_NAV_ITEMS = [
  {
    path: '/influencer/tasks',
    label: 'My Tasks',
    description: 'Upload deliverables and confirm when posts are live.',
  },
  {
    path: '/influencer/campaigns',
    label: 'My Campaigns',
    description: 'Campaign overview, briefs, and invitations.',
  },
  {
    path: '/influencer/submissions',
    label: 'My Submissions',
    description: 'History of files you uploaded for review.',
  },
]

/**
 * @param {string} path
 */
export function getInfluencerNavDescription(path) {
  return INFLUENCER_NAV_ITEMS.find((item) => item.path === path)?.description || ''
}
